import { Theme } from './Theme'
import { ScreenSize } from 'src/ui/style/ScreenSize'

const primaryColor = '#9DDBF4'
const secondaryColor = '#F3D03E'
const tertiaryColor = '#00B2EE'

export const appTheme = (): Theme => ({
    colors: {
        primary: primaryColor,
        secondary: secondaryColor,
        tertiary: tertiaryColor,
        eyeCatcher: '#e87722',
        firstMonthFreeBadge: '#FE0000',
        background: '#e1f4fe',
        white: '#ffffff',
        black: '#000000',
        error: '#901d1d',
        lightGray: '#dddddd',
        darkGray: '#555555',
        gray: '#a8a8a8',
        outline: primaryColor,
        hover: '#dddddd',
        whiteWithOpacity: 'rgba(255, 255, 255, 0.83)',
        lightBlue: '#D9F4FF',
        okGreen: '#78BD70',
        blackWithOpacity: 'rgba(0, 0, 0, 0.4)'
    },
    fonts: {
        primary: 'Roboto, arial, sans-serif'
    },
    fontColor: {
        primary: '#666666'
    },
    fontSize: {
        xl: '32px',
        lg: '28px',
        md: '20px',
        sm: '16px',
        xs: '14px',
        xxs: '12px'
    },
    fontWeight: {
        thin: 300,
        normal: 400,
        bold: 700
    },
    lineHeight: {
        xl: '32px'
    },
    letterSpacing: {
        lg: '0.8px',
        xl: '10.2px'
    },
    spacing: {
        sm: '0.5rem',
        md: '1rem',
        lg: '2rem',
        xl: '6rem'
    },
    screens: {
        xs: `${ScreenSize.Sizes.xs}px`,
        sm: `${ScreenSize.Sizes.sm}px`,
        md: `${ScreenSize.Sizes.md}px`,
        lg: `${ScreenSize.Sizes.lg}px`,
        xl: `${ScreenSize.Sizes.xl}px`
    },
    borderRadius: {
        primary: '0',
        secondary: '33px'
    },
    boxShadow: {
        bottomOnly: '0px 8px 10px -8px rgba(0, 0, 0, 0.4)',
        around: `0px 0px 10px 1px ${primaryColor}`
    },
    iconToTextSizeRatio: '140%',
    /*
     * Solid outline style is rectangle with sharp corners around focused element
     * so we are using this style, because we have border-radius on our elements set to 0.
     * Auto outline style is with rectangle with rounded corners around focused element, so it doesnt't suit us
     */
    outline: `1px solid ${primaryColor}`,
    containerMaxWidth: '1140px',
    border: {
        primary: `1px solid ${primaryColor}`
    }
})
